var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { action, observable, runInAction } from 'mobx';
import React from 'react';
import { ColorCodedState } from '../@types/ui.controller.types';
import BaseSpacer from '../components/BaseSpacer/BaseSpacer';
import Dialog from '../components/Dialog/dialog.constructor';
import ErrorRenderer from '../components/ErrorRenderer/ErrorRenderer';
import { renderRenderable } from '../utils/components.utils';
export var makeDialogController = function () {
    var c = observable({
        dialogs: [],
        present: action(function (d) {
            return new Promise(function (resolve, reject) {
                var dialog = new Dialog(d, c);
                runInAction(function () { return c.dialogs.push(dialog); });
                resolve(dialog.promise);
            });
        }),
        positive: action(function (d) {
            return c.present(__assign({ colorCodedState: ColorCodedState.success, defaultActions: d.actions ? undefined : ['positive'] }, d));
        }),
        success: action(function (d) {
            return c.present(__assign({ colorCodedState: ColorCodedState.success, defaultActions: d.actions ? undefined : ['positive'] }, d));
        }),
        attention: action(function (d) {
            return c.present(__assign({ colorCodedState: ColorCodedState.attention, defaultActions: d.actions ? undefined : ['positive'] }, d));
        }),
        alert: action(function (d) {
            return c.present(__assign({ colorCodedState: ColorCodedState.alert, defaultActions: d.actions ? undefined : ['positive'] }, d));
        }),
        error: action(function (d) {
            return c.present(__assign(__assign({ colorCodedState: ColorCodedState.error, defaultActions: d.actions ? undefined : ['positive'] }, d), d.error ? {
                body: React.createElement(React.Fragment, null,
                    d.body && React.createElement(React.Fragment, null,
                        React.createElement(BaseSpacer, { size: ".5em" }),
                        renderRenderable(d.body)),
                    React.createElement(ErrorRenderer, { e: d.error })),
            } : null));
        }),
        dismiss: action(function (d) {
            var index = c.dialogs.findIndex(function (dialog) { return typeof d === 'string' ? dialog.config.name === d : dialog === d; });
            var dialog = c.dialogs[index];
            if (!dialog)
                return;
            if (dialog.status === 'closed') {
                c.dialogs.splice(index, 1);
            }
            else {
                dialog.close();
            }
        }),
        get hasDialogs() {
            return c.dialogs.filter(function (o) { return o.status === 'opened'; }).length > 0;
        },
        get lastDialog() {
            return c.dialogs[c.dialogs.length - 1];
        },
        reset: action(function () {
            c.dialogs.splice(0);
        })
    });
    return c;
};
